/* Solerza — kleurstalen tussen producten
   -------------------------------------------------------------------
   Zet bovenaan de configurator een rij stofstalen van dezelfde stof in
   andere kleuren. Werkt zonder aanpassing in Shopify: de productlijst
   komt van /products.json en de familie wordt uit de handle gelezen.

   Handle-opbouw waar dit op rekent:

     plissegordijn-draai-kiepraam-verduisterend-aqua-bruin
     └─────── basis (type + model) ──────┘ └dim┘ └col┘ └kleur┘

   Het woord "verduisterend" of "lichtdoorlatend" is het anker. Alles
   ervoor is de stof/het model (moet gelijk zijn), het eerste woord erna
   is de stofcollectie, de rest is de kleurnaam.

   Plaatsing: bovenaan de configurator, boven stap 1.
   Klik: navigeert naar het kleurproduct en zet de al gemaakte keuzes terug.

   Laden na de configurator:
     <script src="{{ 'solerza-kleuren.js' | asset_url }}" defer></script>
   ------------------------------------------------------------------- */
(function () {
  "use strict";

  var DEBUG = false;
  var CACHE_KEY = "slz_products_v3";
  var CACHE_MIN = 60;                 /* productlijst zo lang hergebruiken */
  var RESTORE_KEY = "slz_restore_v1"; /* keuzes meenemen naar het volgende product */
  var MAX_SWATCHES = 5;               /* in de configurator; rest via "Meer kleuren" */
  var DIM = ["verduisterend", "lichtdoorlatend", "transparant", "semi-transparant"];

  /* Producten waarbij de kleurenrij niet moet verschijnen: bij horren
     verschillen de handles vooral in model, niet in kleur. */
  var SKIP = [/(^|-)hor(-|$)/, /(^|-)horren(-|$)/, /hordeur/, /plisséhor/, /plissehor/, /rolhor/, /raamhor/, /inzethor/];

  /* Kleurwoorden. Nodig voor producten zonder verduisterend/lichtdoorlatend
     in de handle (bv. houten jaloezieën): daar wordt de kleur aan het einde
     van de handle herkend met deze lijst. */
  var COLORWORDS = ("wit,zwart,grijs,lichtgrijs,donkergrijs,antraciet,taupe,creme,crème,ecru,beige," +
    "bruin,lichtbruin,donkerbruin,blauw,lichtblauw,donkerblauw,groen,lichtgroen,donkergroen," +
    "geel,oranje,roze,rood,paars,zilver,goud,brons,zand,camel,koffie,chalk,cotton,dove,jet," +
    "lunar,mist,pebble,slate,steel,toffee,truffle,vanilla,barley,hessian,galant," +
    "naturel,natural,natuurlijk,magnolia,champagne,antiek,rustiek,gelakt,geolied," +
    "eiken,noten,notenhout,kers,mahonie,teak,wenge,bamboe,olijf,es,beuken," +
    "zacht,licht,donker,warm,koel,off,white,black,grey,gray,dark,light").split(",");

  function isColorWord(w) {
    return COLORWORDS.indexOf(w) !== -1;
  }

  /* ---------------- profiel voor jaloezieën ----------------
     De handles zijn hier onregelmatig: de maat staat er soms niet in, het
     type wisselt tussen "jaloezie" en "houten-jaloezieen", en de kleur kan
     uit meerdere woorden bestaan. Dit profiel legt de regels vast.

       lindehout-jaloezie-zwart               → lindehout · 50mm · zwart
       lindehout-jaloezie-25mm-wit            → lindehout · 25mm · wit
       paulownia-houten-jaloezieen-natuurlijk → paulownia · 50mm · natuurlijk
       bamboe-jaloezie-25mm-natuurlijk-licht-bruin
                                              → bamboe · 25mm · natuurlijk licht bruin
       aluminium-jaloezie-zwart               → aluminium · 25mm · zwart
       aluminium-jaloezie-geperforeerd-magnolia-35-50mm
                                  → aluminium · 35-50mm · geperforeerd · magnolia
     -------------------------------------------------------- */
  var BLIND_TYPE = /(^|-)(jaloezie|jaloezieen|jaloezieën)(-|$)/;

  /* woorden die bij de opbouw horen en dus nooit een kleur zijn */
  var STRUCT = ["jaloezie", "jaloezieen", "jaloezieën", "houten", "hout", "horizontale",
    "verticale", "geperforeerd", "op", "maat", "vouwgordijn"];

  /* standaardmaat als die niet in de handle staat */
  var DEFAULT_SIZE = { aluminium: "25mm" };
  var DEFAULT_SIZE_FALLBACK = "50mm";

  /* Materiaalgroepen: hout en aluminium blijven gescheiden. Een materiaal
     dat hier niet staat, vormt zijn eigen groep. */
  /* Volgorde van collecties in "Meer kleuren". Wat hier niet staat komt
     erna, alfabetisch. De eigen collectie staat altijd bovenaan. */
  var COLLECTION_ORDER = [];   /* leeg = automatisch op prijs */

  function groupPrice(list) {
    var p = (list || []).map(function (i) { return i.price || 0; })
      .filter(function (n) { return n > 0; });
    return p.length ? Math.min.apply(null, p) : Infinity;
  }

  var MATERIAL_CLASS = {
    lindehout: "hout", paulownia: "hout", bamboe: "hout", abachi: "hout",
    abaci: "hout", basswood: "hout", eiken: "hout", grenen: "hout",
    aluminium: "aluminium"
  };

  function blindParse(h) {
    var parts = (h || "").split("-");
    if (parts.length < 3 || !BLIND_TYPE.test(h)) return null;

    var material = parts[0];
    var size = "";
    var perf = false;
    var color = [];

    for (var i = 1; i < parts.length; i++) {
      var s = parts[i];
      if (/^\d+mm$/.test(s)) { size = s; continue; }
      /* maatbereik als twee segmenten: 35 + 50mm */
      if (/^\d+$/.test(s) && /^\d+mm$/.test(parts[i + 1] || "")) {
        size = s + "-" + parts[i + 1];
        i++;
        continue;
      }
      if (/^\d/.test(s)) continue;                 /* overige cijfers negeren */
      if (s === "geperforeerd") { perf = true; continue; }
      if (STRUCT.indexOf(s) !== -1) continue;
      color.push(s);
    }
    if (!color.length) return null;
    if (!size) size = DEFAULT_SIZE[material] || DEFAULT_SIZE_FALLBACK;

    return {
      material: material,
      size: size,
      perf: perf,
      color: color.join("-"),
      /* familie: zelfde materiaalsoort, maat en uitvoering.
         Hout en aluminium worden dus nooit gemengd. */
      key: (MATERIAL_CLASS[material] || material) + "|" + size + (perf ? "|perf" : ""),
      handle: h
    };
  }

  function familyByProfile(items, h) {
    var me = blindParse(h);
    if (!me) return null;
    var groups = {};
    items.forEach(function (it) {
      var p = blindParse(it.h);
      if (!p || p.key !== me.key) return;
      if (!groups[p.material]) groups[p.material] = [];
      groups[p.material].push({
        handle: it.h, title: it.t, img: it.img, ok: it.ok, price: it.p || 0,
        color: p.color, label: titleCase(p.color)
      });
    });
    var n = Object.keys(groups).reduce(function (a, k) { return a + groups[k].length; }, 0);
    if (n < 2) return null;
    Object.keys(groups).forEach(function (k) {
      groups[k].sort(function (a, b) { return a.label.localeCompare(b.label); });
    });
    log("jaloezie-profiel:", me.key, "->",
      Object.keys(groups).map(function (k) { return k + ":" + groups[k].length; }).join(", "));
    return { groups: groups, me: me };
  }

  function log() {
    if (DEBUG) console.log.apply(console, ["[solerza-kleuren]"].concat([].slice.call(arguments)));
  }

  function handle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : "";
  }

  /* ---------------- handle ontleden ---------------- */
  function parse(h) {
    var parts = (h || "").split("-");
    var di = -1;
    for (var i = 0; i < parts.length; i++) {
      if (DIM.indexOf(parts[i]) !== -1) { di = i; break; }
    }
    if (di === -1) {
      /* Geen verduistering in de handle: de kleur is het achtervoegsel dat
         volledig uit kleurwoorden bestaat ("houten-jaloezie-50mm-zacht-wit"). */
      var k = parts.length;
      while (k > 1 && isColorWord(parts[k - 1])) k--;
      if (k === parts.length) return null;      /* geen kleur te vinden */
      return {
        base: parts.slice(0, k).join("-"),
        dim: "",
        collection: "",
        color: parts.slice(k).join("-"),
        handle: h
      };
    }
    if (di === parts.length - 1) return null;
    return {
      base: parts.slice(0, di).join("-"),        /* stof + model */
      dim: parts[di],                            /* verduistering */
      collection: parts[di + 1] || "",           /* stofcollectie */
      color: parts.slice(di + 2).join("-"),      /* kleurnaam */
      handle: h
    };
  }

  function titleCase(s) {
    return (s || "").split("-").filter(Boolean).map(function (w) {
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(" ");
  }

  /* ---------------- productlijst ---------------- */
  function cached() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.t || Date.now() - o.t > CACHE_MIN * 60000) return null;
      return o.items;
    } catch (e) { return null; }
  }

  function store(items) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), items: items }));
    } catch (e) {}
  }

  function fetchPage(page) {
    return fetch("/products.json?limit=250&page=" + page, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return (d && d.products) || []; })
      .catch(function () { return []; });
  }

  function loadProducts() {
    var c = cached();
    if (c) return Promise.resolve(c);
    var all = [];
    /* achtereenvolgens ophalen tot een lege pagina; max 6 pagina's (1500) */
    function step(p) {
      if (p > 6) return Promise.resolve();
      return fetchPage(p).then(function (list) {
        if (!list.length) return;
        list.forEach(function (pr) {
          var imgs = (pr.images || []).map(function (i) { return i.src; });
          var prices = (pr.variants || [])
            .map(function (v) { return parseFloat(v.price); })
            .filter(function (n) { return !isNaN(n) && n > 0; });
          all.push({
            h: pr.handle,
            t: pr.title,
            p: prices.length ? Math.min.apply(null, prices) : 0,
            /* tweede foto = stofstaal, anders de hoofdfoto */
            img: imgs[1] || imgs[0] || "",
            ok: (pr.variants || []).some(function (v) { return v.available; })
          });
        });
        return step(p + 1);
      });
    }
    return step(1).then(function () {
      log("producten geladen:", all.length);
      store(all);
      return all;
    });
  }

  /* ---------------- familie bepalen ---------------- */
  /* Geen kleurwoord gevonden? Dan de kleur bepalen door handles onderling te
     vergelijken: verschillen twee handles in precies één blok van 1-2
     segmenten en is de rest identiek, dan is dat blok de kleur. Zo werkt het
     ook als de kleur in het midden staat:

       aluminium-jaloezie-geperforeerd-[zwart]-35-50mm
       lindehout-jaloezie-25mm-[wit]
       bamboe-jaloezie-[donkerbruin]

     ---------------------------------------------------------------- */
  function diffBlock(a, b) {
    /* geeft {mine, other} met het verschillende blok, of null */
    var p = 0;
    while (p < a.length && p < b.length && a[p] === b[p]) p++;
    var s = 0;
    while (s < a.length - p && s < b.length - p &&
           a[a.length - 1 - s] === b[b.length - 1 - s]) s++;
    var ma = a.slice(p, a.length - s);
    var mb = b.slice(p, b.length - s);
    if (!ma.length || !mb.length) return null;      /* niets of alles verschilt */
    if (ma.length > 2 || mb.length > 2) return null; /* te groot voor een kleur */
    if (p < 2) return null;                          /* ander producttype */
    /* een blok met cijfers is een maat (25mm, 35-50mm), geen kleur */
    if (ma.concat(mb).some(function (s) { return /\d/.test(s); })) return null;
    /* verduistering is geen kleur: verduisterend hoort nooit bij lichtdoorlatend */
    if (ma.concat(mb).some(function (s) { return DIM.indexOf(s) !== -1; })) return null;
    return { mine: ma.join("-"), other: mb.join("-"), at: p };
  }

  function dimOf(h) {
    var parts = (h || "").split("-");
    for (var i = 0; i < parts.length; i++) {
      if (DIM.indexOf(parts[i]) !== -1) return parts[i];
    }
    return "";
  }

  function familyByPrefix(items, h) {
    var myDim = dimOf(h);
    var a = (h || "").split("-");
    if (a.length < 3) return null;
    var list = [], myColor = "";
    items.forEach(function (it) {
      if (it.h === h) return;
      if (dimOf(it.h) !== myDim) return;   /* andere verduistering: nooit dezelfde familie */
      var d = diffBlock(a, it.h.split("-"));
      if (!d) return;
      if (!myColor) myColor = d.mine;
      if (d.mine !== myColor) return;   /* verschil op een andere plek: niet dezelfde familie */
      list.push({
        handle: it.h, title: it.t, img: it.img, ok: it.ok, price: it.p || 0,
        color: d.other, label: titleCase(d.other)
      });
    });
    if (!list.length) return null;
    var self = items.filter(function (i) { return i.h === h; })[0];
    if (self) {
      list.push({
        handle: h, title: self.t, img: self.img, ok: self.ok, price: self.p || 0,
        color: myColor, label: titleCase(myColor)
      });
    }
    list.sort(function (x, y) { return x.label.localeCompare(y.label); });

    /* Zelfde soort in een ander materiaal (lindehout, bamboe, abachi …).
       De structuur van die handles kan afwijken (soms zonder maat), dus
       hier alleen eisen: zelfde producttype en — als beide een maat
       hebben — dezelfde maat. De kleur bepalen we binnen die groep
       door de handles onderling te vergelijken. */
    var groups = {};
    groups[a[0]] = list;

    function sizes(arr) {
      return arr.filter(function (s) { return /\d/.test(s); }).join("-");
    }
    var mySize = sizes(a);

    var byMat = {};
    items.forEach(function (it) {
      var b = it.h.split("-");
      if (b.length < 3 || b[0] === a[0]) return;
      if (b[1] !== a[1]) return;                       /* ander producttype */
      if (dimOf(it.h) !== myDim) return;               /* andere verduistering */
      var bs = sizes(b);
      if (mySize && bs && bs !== mySize) return;       /* andere maat */
      if (!byMat[b[0]]) byMat[b[0]] = [];
      byMat[b[0]].push(it);
    });

    Object.keys(byMat).forEach(function (mat) {
      var arr = byMat[mat];
      var res = [];
      arr.forEach(function (it) {
        var b = it.h.split("-");
        var color = "";
        for (var i = 0; i < arr.length && !color; i++) {
          if (arr[i].h === it.h) continue;
          var d = diffBlock(b, arr[i].h.split("-"));
          if (d) color = d.mine;
        }
        /* enkel product in deze groep: kleur is het laatste woord zonder cijfers */
        if (!color) {
          var last = b[b.length - 1];
          if (/\d/.test(last)) return;
          color = last;
        }
        res.push({
          handle: it.h, title: it.t, img: it.img, ok: it.ok, price: it.p || 0,
          color: color, label: titleCase(color)
        });
      });
      if (res.length) groups[mat] = res;
    });
    Object.keys(groups).forEach(function (k) {
      groups[k].sort(function (x, y) { return x.label.localeCompare(y.label); });
    });
    log("familie via handle-vergelijking:", myColor, "->",
      Object.keys(groups).map(function (k) { return k + ":" + groups[k].length; }).join(", "));
    return groups;
  }

  function family(items, me) {
    var out = {};
    items.forEach(function (it) {
      var p = parse(it.h);
      if (!p) return;
      if (p.base !== me.base || p.dim !== me.dim) return;
      var key = p.collection || "kleuren";
      if (!out[key]) out[key] = [];
      out[key].push({
        handle: it.h,
        title: it.t,
        img: it.img,
        ok: it.ok,
        price: it.p || 0,
        color: p.color,
        label: titleCase(p.color)
      });
    });
    Object.keys(out).forEach(function (k) {
      out[k].sort(function (a, b) { return a.label.localeCompare(b.label); });
    });
    return out;
  }

  /* ---------------- keuzes meenemen ---------------- */
  function snapshotChoices() {
    var out = [];
    try {
      var root = document.querySelector(".product-custom-option");
      if (!root) return out;
      var idx = -1;
      [].slice.call(root.querySelectorAll(".optionHolder")).forEach(function (h) {
        idx++;
        var name = (h.querySelector(".option-label, .slz-step__title, .instruction h2") || {}).textContent || "";
        name = name.replace(/\*/g, "").replace(/^\s*\d+\s*/, "").replace(/\s+/g, " ").trim();
        if (!name) return;
        var val = "";
        var ch = h.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
        if (ch) {
          var lb = h.querySelector('label[for="' + ch.id + '"]');
          val = (ch.dataset.value || (lb && lb.textContent) || "").trim();
        }
        var dd = h.querySelector(".selected-dropdown-view .dropdown-label, .selected-dropdown-view label");
        if (!val && dd) val = dd.textContent.trim();
        var sel = h.querySelector("select");
        if (!val && sel && sel.value) val = sel.options[sel.selectedIndex].textContent.trim();
        var num = [].slice.call(h.querySelectorAll(".measurement-input"));
        if (num.length) {
          var filled = num.filter(function (n) { return n.value !== ""; });
          val = filled.length
            ? filled.map(function (n) { return n.dataset.value + ":" + n.value; }).join("|")
            : "";
        }
        var txt = h.querySelector('input[type="text"]:not(.dropbtn), textarea');
        if (!val && txt && txt.value) val = txt.value.trim();
        /* alleen de afmeting meenemen naar het andere product */
        if (val && /(length|width):/.test(val)) out.push({ n: name.toLowerCase(), v: val, i: idx });
      });
    } catch (e) {}
    return out;
  }

  function saveForNext() {
    try {
      sessionStorage.setItem(RESTORE_KEY, JSON.stringify({
        t: Date.now(), items: snapshotChoices()
      }));
    } catch (e) {}
  }

  function restoreChoices() {
    var data;
    try {
      var raw = sessionStorage.getItem(RESTORE_KEY);
      if (!raw) return;
      data = JSON.parse(raw);
    } catch (e) { return; }
    if (!data || !data.items || !data.items.length || Date.now() - data.t > 600000) {
      try { sessionStorage.removeItem(RESTORE_KEY); } catch (e2) {}
      return;
    }

    /* De app bouwt de opties opnieuw op na elke keuze (regels), dus niet in
       één keer alles zetten: telkens één ontbrekende keuze toepassen, even
       wachten en opnieuw kijken. */
    var todo = data.items.slice();
    var t0 = Date.now();
    var busy = false;
    var placed = 0;

    function findStep(item) {
      var root = document.querySelector(".product-custom-option");
      if (!root) return null;
      var hit = null;
      [].slice.call(root.querySelectorAll(".optionHolder")).forEach(function (h) {
        if (hit) return;
        var nm = (h.querySelector(".option-label, .slz-step__title, .instruction h2") || {}).textContent || "";
        nm = nm.replace(/\*/g, "").replace(/^\s*\d+\s*/, "").replace(/\s+/g, " ").trim().toLowerCase();
        if (!nm) return;
        if (nm === item.n || nm.indexOf(item.n) === 0 || item.n.indexOf(nm) === 0) hit = h;
      });
      if (!hit && typeof item.i === "number") {
        var all = [].slice.call(root.querySelectorAll(".optionHolder"));
        var cand = all[item.i];
        /* alleen gebruiken als daar hetzelfde soort keuze staat */
        if (cand && cand.offsetParent !== null) {
          var wantDim = /(length|width):/.test(item.v);
          var hasDim = !!cand.querySelector(".measurement-input");
          if (wantDim === hasDim) hit = cand;
        }
      }
      return hit;
    }

    function same(a, b) {
      return (a || "").replace(/\s+/g, " ").trim().toLowerCase() ===
             (b || "").replace(/\s+/g, " ").trim().toLowerCase();
    }

    /* de configurator laten weten dat deze stap een bewuste keuze heeft */
    function confirmStep(h) {
      try {
        var api = window.SolerzaConfig;
        if (!api || !h || !h.dataset || !h.dataset.slzKey) return;
        api.state.confirmed[h.dataset.slzKey] = true;
        api.state.userAction = true;
      } catch (e) {}
    }

    function isSet(item, h) {
      if (/(length|width):/.test(item.v)) {
        return item.v.split("|").every(function (pair) {
          var kv = pair.split(":");
          var inp = h.querySelector('.measurement-input[data-value="' + kv[0] + '"]');
          return inp && inp.value === kv[1];
        });
      }
      var cur = h.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked, .swatch-input:checked');
      if (cur) {
        var lb = h.querySelector('label[for="' + cur.id + '"]');
        if (same(cur.dataset.value || (lb && (lb.getAttribute("title") || lb.textContent)), item.v)) return true;
      }
      var dd = h.querySelector(".selected-dropdown-view .dropdown-label, .selected-dropdown-view label, .opc-selected-name");
      if (dd && same(dd.textContent, item.v)) return true;
      var sel = h.querySelector("select");
      if (sel && sel.selectedIndex > -1 && same(sel.options[sel.selectedIndex].textContent, item.v)) return true;
      return false;
    }

    function apply(item) {
      var h = findStep(item);
      if (!h || h.offsetParent === null) return false;

      /* maten */
      if (/(length|width):/.test(item.v)) {
        var any = false;
        item.v.split("|").forEach(function (pair) {
          var kv = pair.split(":");
          var inp = h.querySelector('.measurement-input[data-value="' + kv[0] + '"]');
          if (inp && inp.value !== kv[1]) {
            inp.value = kv[1];
            ["input", "change", "keyup", "blur"].forEach(function (ev) {
              inp.dispatchEvent(new Event(ev, { bubbles: true }));
            });
            any = true;
          }
        });
        return any;
      }

      /* al goed? */
      var cur = h.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
      if (cur) {
        var lb0 = h.querySelector('label[for="' + cur.id + '"]');
        if (same(cur.dataset.value || (lb0 && lb0.textContent), item.v)) return false;
      }

      /* keuzerondje of staal */
      var hit = null;
      [].slice.call(h.querySelectorAll('input[type="radio"], input[type="checkbox"], .swatch-input')).forEach(function (inp) {
        if (hit) return;
        var lb = h.querySelector('label[for="' + inp.id + '"]');
        var t = inp.dataset.value || (lb && (lb.getAttribute("title") || lb.textContent)) || "";
        if (same(t, item.v)) hit = inp;
      });
      if (hit && !hit.checked) {
        var lab = h.querySelector('label[for="' + hit.id + '"]');
        if (lab) lab.click();
        if (!hit.checked) {
          hit.checked = true;
          hit.click();
        }
        ["input", "change", "click"].forEach(function (ev) {
          hit.dispatchEvent(new Event(ev, { bubbles: true }));
        });
        return true;
      }

      /* eigen keuzelijst van de app */
      var opt = null;
      [].slice.call(h.querySelectorAll(".option-type-dropdown-content .tab-view")).forEach(function (tv) {
        if (opt) return;
        var lbl = tv.querySelector(".dropdown-label, label");
        if (same(tv.getAttribute("title"), item.v) ||
            same(lbl && lbl.textContent, item.v) ||
            same(tv.textContent, item.v)) opt = tv;
      });
      if (opt && !opt.classList.contains("selected-dropdown-view")) {
        opt.click();
        var inp2 = opt.querySelector("input");
        if (inp2) {
          inp2.checked = true;
          ["input", "change"].forEach(function (ev) {
            inp2.dispatchEvent(new Event(ev, { bubbles: true }));
          });
        }
        return true;
      }

      /* gewone keuzelijst */
      var sel = h.querySelector("select");
      if (sel) {
        for (var i = 0; i < sel.options.length; i++) {
          if (same(sel.options[i].textContent, item.v)) {
            if (sel.selectedIndex === i) return false;
            sel.selectedIndex = i;
            sel.dispatchEvent(new Event("change", { bubbles: true }));
            return true;
          }
        }
      }
      return false;
    }

    var timer = setInterval(function () {
      if (busy) return;
      if (!todo.length || Date.now() - t0 > 15000) {
        clearInterval(timer);
        try { sessionStorage.removeItem(RESTORE_KEY); } catch (e3) {}
        var api2 = window.SolerzaConfig;
        if (api2) {
          [].slice.call(document.querySelectorAll(".product-custom-option .optionHolder")).forEach(function (h) {
            if (h.dataset && h.dataset.slzKey) confirmStep(h);
          });
          /* stappen met een keuze dichtklappen; de eerste zonder keuze
             gaat open, en staat alles klaar dan blijft alles dicht */
          try {
            var open = null;
            api2.steps().forEach(function (h) {
              if (open) return;
              var sum = h.querySelector(".slz-step__summary");
              var filled = sum && sum.textContent.replace(/\s+/g, " ").trim() &&
                !/nog kiezen|kies|maak een keuze|vul/i.test(sum.textContent);
              if (!filled) open = h;
            });
            api2.state.openKey = open && open.dataset ? open.dataset.slzKey : "__none__";
            api2.state.userAction = true;
          } catch (e4) {}
          api2.render();
        }
        log("keuzes teruggezet:", placed, "van", data.items.length);
        return;
      }
      if (!document.querySelector(".product-custom-option .optionHolder")) return;

      var item = todo[0];
      if (!item.t0) item.t0 = Date.now();

      var step = findStep(item);
      /* opties komen soms later: per keuze tot 6 seconden blijven proberen */
      if (!step || !step.querySelector('input, select, .tab-view')) {
        if (Date.now() - item.t0 > 6000) { todo.shift(); log("niet gevonden:", item.n); }
        return;
      }

      busy = true;
      var changed = apply(item);
      confirmStep(step);
      if (changed) { placed++; todo.shift(); }
      else if (isSet(item, step) || Date.now() - item.t0 > 6000) {
        if (!isSet(item, step)) log("niet gezet:", item.n, "=", item.v);
        todo.shift();
      }
      setTimeout(function () { busy = false; }, changed ? 320 : 80);
    }, 60);
  }

  /* ---------------- opmaak ---------------- */
  function styles() {
    if (document.getElementById("slz-kleuren-css")) return;
    var s = document.createElement("style");
    s.id = "slz-kleuren-css";
    s.textContent = [
      ".slz-colors{margin:0 0 16px;font-family:inherit}",
      ".slz-colors__head{display:flex;align-items:baseline;justify-content:space-between;gap:12px;margin:0 0 10px}",
      ".slz-colors__title{font-size:13px;font-weight:700;letter-spacing:.02em;color:#0E1730}",
      ".slz-colors__title span{font-weight:500;color:#5B6480;margin-left:6px}",
      ".slz-colors__more{border:0;background:transparent;color:#E68F5D;font:inherit;font-size:12.5px;font-weight:600;cursor:pointer;text-decoration:underline;text-underline-offset:3px;padding:0}",
      ".slz-colors__more:hover{color:#CE7440}",
      ".slz-colors__row{display:grid!important;grid-template-columns:repeat(auto-fill,64px)!important;gap:14px 10px!important;justify-content:start!important;align-items:start!important}",
      ".slz-colors .slz-sw{position:relative!important;flex:0 0 auto!important;width:56px!important;max-width:56px!important;height:auto!important;border:0!important;background:transparent!important;padding:0!important;margin:0!important;cursor:pointer;display:block!important;box-shadow:none!important;overflow:visible!important}",
      ".slz-colors .slz-sw__img{display:block!important;width:100%!important;height:100%!important;max-width:none!important;min-width:0!important;border:0!important;border-radius:0!important;object-fit:cover!important;position:static!important;padding:0!important;margin:0!important;vertical-align:top!important}",
      ".slz-colors .slz-sw__frame{transition:border-color .15s,transform .15s,box-shadow .15s}",
      ".slz-colors .slz-sw:hover .slz-sw__frame{border-color:rgba(18,34,76,.35)!important;transform:translateY(-2px);box-shadow:0 8px 18px -10px rgba(14,23,48,.45)}",

      ".slz-colors .slz-sw.is-current .slz-sw__frame{border-color:#E68F5D!important;box-shadow:0 0 0 3px rgba(230,143,93,.22)}",
      ".slz-colors .slz-sw.is-out .slz-sw__frame{opacity:.45}",
      ".slz-colors .slz-sw__name{position:static!important;padding:0!important}",
      ".slz-colors .slz-sw.is-current .slz-sw__name{color:#0E1730;font-weight:600}",
      ".slz-cmodal{position:fixed;inset:0;z-index:99999;display:flex;align-items:stretch;justify-content:flex-end;background:rgba(10,16,34,.5);opacity:0;transition:opacity .22s;backdrop-filter:blur(2px)}",
      ".slz-cmodal.is-open{opacity:1}",
      ".slz-cmodal__panel{display:flex;flex-direction:column;width:min(560px,100%);height:100%;background:#FBFAF7;border-radius:0;padding:0;transform:translateX(24px);transition:transform .26s cubic-bezier(.22,.7,.25,1);box-shadow:-24px 0 60px -30px rgba(14,23,48,.5)}",
      ".slz-cmodal.is-open .slz-cmodal__panel{transform:none}",
      ".slz-cmodal__top{display:flex;align-items:flex-start;justify-content:space-between;gap:14px;padding:22px 24px 14px;background:#fff;border-bottom:1px solid rgba(18,34,76,.08);flex:none}",
      ".slz-cmodal__title{font-size:20px;font-weight:700;letter-spacing:-.01em;color:#0E1730;margin:0}",
      ".slz-cmodal__x{flex:0 0 36px!important;display:flex;align-items:center;justify-content:center;border:0;background:rgba(18,34,76,.06);width:36px!important;height:36px!important;min-width:36px;max-width:36px;padding:0!important;border-radius:50%!important;font-size:14px;line-height:1;color:#0E1730;cursor:pointer;transition:background .15s,color .15s}",
      ".slz-cmodal__x:hover{background:#12224C;color:#fff}",
      ".slz-cmodal__sub{font-size:12.5px;color:#5B6480;margin:5px 0 0}",
      ".slz-cmodal__nav{display:flex;gap:7px;overflow-x:auto;padding:12px 24px;background:#fff;border-bottom:1px solid rgba(18,34,76,.08);flex:none;scrollbar-width:none}",
      ".slz-cmodal__nav::-webkit-scrollbar{display:none}",
      ".slz-chip{flex:none;border:1px solid rgba(18,34,76,.14);background:#fff;border-radius:999px;padding:7px 13px;font:inherit;font-size:12px;font-weight:600;color:#5B6480;cursor:pointer;white-space:nowrap;transition:background .15s,color .15s,border-color .15s}",
      ".slz-chip:hover{border-color:rgba(18,34,76,.3);color:#12224C}",
      ".slz-chip.is-on{background:#12224C;border-color:#12224C;color:#fff}",
      ".slz-cmodal__body{flex:1 1 auto!important;min-height:0!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch;padding:18px 24px 34px}",
      ".slz-cgroup{margin:0 0 26px}",
      ".slz-cgroup__t{display:flex;align-items:center;gap:9px;font-size:13.5px;font-weight:700;color:#12224C;margin:0 0 12px;text-transform:none}",
      ".slz-cgroup__now{font-size:10.5px;font-weight:700;color:#C2703F;background:rgba(230,143,93,.14);border-radius:999px;padding:3px 9px}",
      ".slz-cgroup__row{display:grid!important;grid-template-columns:repeat(auto-fill,minmax(72px,1fr))!important;gap:12px!important}",
      ".slz-cmodal .slz-sw{position:relative!important;width:100%!important;max-width:none!important;border:0!important;background:transparent!important;padding:0!important;cursor:pointer;display:block!important}",
      ".slz-cmodal .slz-sw__frame{width:100%!important;height:72px!important}",

      ".slz-cmodal .slz-sw__name{display:block!important;position:static!important;margin-top:5px;font-size:11px;line-height:1.25;color:#5B6480;text-align:center}",
      ".slz-skel{display:block;padding:2px 0}",
      ".slz-skel__row{height:58px;border-radius:16px;margin:0 0 7px;background:linear-gradient(90deg,rgba(18,34,76,.05) 25%,rgba(18,34,76,.09) 37%,rgba(18,34,76,.05) 63%);background-size:400% 100%;animation:slz-shine 1.3s ease-in-out infinite}",
      "@keyframes slz-shine{0%{background-position:100% 0}100%{background-position:0 0}}",
      ".slz-load{position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center;background:rgba(248,247,244,.82);opacity:0;transition:opacity .16s}",
      ".slz-load.is-on{opacity:1}",
      ".slz-load__box{display:flex;align-items:center;gap:11px;background:#fff;border-radius:14px;padding:15px 22px;font-size:14.5px;font-weight:600;color:#12224C;box-shadow:0 14px 34px -16px rgba(14,23,48,.4)}",
      ".slz-load__dot{width:16px;height:16px;border-radius:50%;border:2.5px solid rgba(18,34,76,.18);border-top-color:#E68F5D;animation:slz-spin .7s linear infinite}",
      "@keyframes slz-spin{to{transform:rotate(360deg)}}",
      "@media (max-width:749px){.slz-cmodal__panel{width:100%}.slz-cmodal__top{padding:18px 18px 12px}.slz-cmodal__body{padding:16px 18px 30px}}",
      "@media (max-width:749px){.slz-colors__row{grid-template-columns:repeat(auto-fill,58px)!important;gap:12px 8px!important}}",
      ".slz-colors,.slz-colors__row{max-width:100%!important}",
      ".slz-colors__row.is-swipe{display:flex!important;grid-template-columns:none!important;grid-auto-flow:unset!important;flex-wrap:nowrap!important;justify-content:flex-start!important;overflow-x:auto!important;overflow-y:hidden!important;gap:10px!important;padding:2px 2px 10px!important;margin:0!important;width:100%!important;scroll-snap-type:x proximity;-webkit-overflow-scrolling:touch;scrollbar-width:none}",
      ".slz-colors__row.is-swipe::-webkit-scrollbar{display:none}",
      ".slz-colors__row.is-swipe>.slz-sw{flex:0 0 auto!important;scroll-snap-align:start}"
    ].join("");
    document.head.appendChild(s);
  }

  /* ---------------- weergave ---------------- */
  function swatch(it, cur) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "slz-sw" + (it.handle === cur ? " is-current" : "") + (it.ok ? "" : " is-out");
    b.style.cssText = "display:block;flex:0 0 auto;width:64px;border:0;background:transparent;" +
      "padding:0;margin:0;cursor:pointer;overflow:visible;text-align:center";
    b.title = it.label + (it.ok ? "" : " — tijdelijk niet leverbaar");
    b.innerHTML = '<img class="slz-sw__img" alt="' + it.label +
      '" style="display:block;width:100%;height:100%;object-fit:cover;border-radius:0;margin:0;' +
      'padding:0;max-width:none;min-width:0;min-height:0;border:0;vertical-align:top" src="' +
      it.img + '"><span class="slz-sw__name" style="display:-webkit-box;-webkit-line-clamp:2;' +
      "-webkit-box-orient:vertical;overflow:hidden;width:64px;margin:6px auto 0;" +
      "font-size:10.5px;line-height:1.2;text-align:center;white-space:normal;overflow-wrap:break-word;" +
      "word-break:break-word;color:" + (it.handle === cur ? "#0E1730;font-weight:600" : "#5B6480") + '">' +
      it.label + "</span>";
    if (window.matchMedia && window.matchMedia("(max-width:749px)").matches) {
      b.style.width = "58px";
    }
    var im = b.querySelector("img");
    var frame = document.createElement("span");
    frame.className = "slz-sw__frame";
    frame.style.cssText = "display:block;width:64px;height:64px;margin:0 auto;border-radius:13px;overflow:hidden;" +
      "padding:0;line-height:0;font-size:0;" +
      "background:#F2F1EC;border:2px solid " + (it.handle === cur ? "#E68F5D" : "rgba(18,34,76,.10)") + ";" +
      "box-sizing:border-box";
    if (b.style.width === "58px") {
      frame.style.width = "58px";
      frame.style.height = "58px";
      b.querySelector(".slz-sw__name").style.width = "58px";
    }
    b.insertBefore(frame, im);
    frame.appendChild(im);
    b.addEventListener("click", function () {
      if (it.handle === cur) return;
      overlay("Kleur wordt geladen…");
      saveForNext();
      location.href = "/products/" + it.handle;
    });
    return b;
  }

  function openModal(groups, me) {
    var host = document.createElement("div");
    host.className = "slz-colors-host";
    host.setAttribute("style",
      "position:fixed!important;top:0!important;left:0!important;right:0!important;" +
      "bottom:0!important;display:block!important;width:100%!important;height:100%!important;" +
      "margin:0!important;padding:0!important;border:0!important;visibility:visible!important;" +
      "opacity:1!important;pointer-events:auto!important;z-index:2147483000!important");
    document.body.appendChild(host);
    var sr = host.attachShadow ? host.attachShadow({ mode: "open" }) : null;
    if (!sr) { host.remove(); log("shadow dom niet beschikbaar"); return; }

    var names = Object.keys(groups).sort(function (a, b) {
      if (a === me.collection) return -1;
      if (b === me.collection) return 1;
      var ia = COLLECTION_ORDER.indexOf(a), ib = COLLECTION_ORDER.indexOf(b);
      if (ia !== -1 && ib !== -1) return ia - ib;
      if (ia !== -1) return -1;
      if (ib !== -1) return 1;
      /* automatisch: goedkoopste collectie eerst */
      var pa = groupPrice(groups[a]), pb = groupPrice(groups[b]);
      if (pa !== pb) return pa - pb;
      return a.localeCompare(b);
    });
    var total = names.reduce(function (n, k) { return n + groups[k].length; }, 0);

    var css = [
      ":host{display:block;position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483000}",
      "*{box-sizing:border-box;margin:0;padding:0;font-family:inherit}",
      ".w{position:fixed;inset:0;display:flex;justify-content:flex-end;background:rgba(10,16,34,.5);opacity:0;transition:opacity .22s;font-family:ui-sans-serif,system-ui,-apple-system,'Segoe UI',sans-serif}",
      ".w.on{opacity:1}",
      ".p{display:flex;flex-direction:column;width:min(580px,100%);height:100%;background:#FBFAF7;transform:translateX(26px);transition:transform .26s cubic-bezier(.22,.7,.25,1);box-shadow:-24px 0 60px -30px rgba(14,23,48,.5)}",
      ".w.on .p{transform:none}",
      ".t{display:flex;align-items:flex-start;justify-content:space-between;gap:14px;flex:none;padding:22px 24px 16px;background:#fff;border-bottom:1px solid rgba(18,34,76,.08)}",
      ".t h3{font-size:20px;font-weight:700;letter-spacing:-.01em;color:#0E1730}",
      ".t p{margin-top:5px;font-size:12.5px;color:#5B6480}",
      ".x{flex:0 0 36px;display:flex;align-items:center;justify-content:center;width:36px;height:36px;border:0;border-radius:50%;background:rgba(18,34,76,.06);color:#0E1730;font-size:15px;cursor:pointer}",
      ".x:hover{background:#12224C;color:#fff}",
      ".b{flex:1 1 auto;min-height:0;overflow-y:auto;padding:20px 24px 36px}",
      ".g{margin-bottom:28px}",
      ".g h4{display:flex;align-items:center;gap:9px;margin-bottom:13px;font-size:13.5px;font-weight:700;color:#12224C}",
      ".now{font-size:10.5px;font-weight:700;color:#C2703F;background:rgba(230,143,93,.14);border-radius:999px;padding:3px 9px}",
      ".r{display:grid;grid-template-columns:repeat(auto-fill,88px);gap:20px 14px;justify-content:start}",
      ".s{display:flex;flex-direction:column;align-items:center;gap:8px;width:88px;border:0;background:none;padding:0;cursor:pointer}",
      ".s.out{opacity:.5}",
      ".f{display:block;width:88px;height:88px;border-radius:14px;overflow:hidden;background:#F2F1EC;border:2px solid rgba(18,34,76,.10);transition:border-color .15s,transform .15s,box-shadow .15s}",
      ".s:hover .f{border-color:rgba(18,34,76,.35);transform:translateY(-2px);box-shadow:0 10px 20px -12px rgba(14,23,48,.5)}",
      ".s.cur .f{border-color:#E68F5D;box-shadow:0 0 0 3px rgba(230,143,93,.22)}",
      ".f img{display:block;width:100%;height:100%;object-fit:cover}",
      ".n{font-size:11.5px;line-height:1.25;color:#5B6480;text-align:center;word-break:break-word}",
      ".s.cur .n{color:#0E1730;font-weight:700}",
      "@media (max-width:749px){.p{width:100%}.t{padding:18px 18px 14px}.b{padding:18px 18px 30px}.r{grid-template-columns:repeat(auto-fill,76px);gap:18px 12px}.s,.f{width:76px}.f{height:76px}}"
    ].join("");

    var html = '<div class="w"><div class="p">' +
      '<div class="t"><div><h3>Kies je kleur</h3><p>' + total + " kleuren" +
      (me.dim ? " · " + titleCase(me.dim) : "") + " · zelfde stof en model</p></div>" +
      '<button type="button" class="x" aria-label="Sluiten">✕</button></div><div class="b">';
    names.forEach(function (n) {
      html += '<div class="g"><h4>' + titleCase(n) + (n === "kleuren" ? "" : " collectie") +
        (n === me.collection ? '<span class="now">gekozen collectie</span>' : "") + "</h4><div class=\"r\">";
      groups[n].forEach(function (it) {
        html += '<button type="button" class="s' + (it.handle === me.handle ? " cur" : "") +
          (it.ok ? "" : " out") + '" data-h="' + it.handle + '" title="' + it.label +
          (it.ok ? "" : " — tijdelijk niet leverbaar") + '">' +
          '<span class="f"><img alt="' + it.label + '" src="' + it.img + '"></span>' +
          '<span class="n">' + it.label + "</span></button>";
      });
      html += "</div></div>";
    });
    html += "</div></div></div>";

    sr.innerHTML = "<style>" + css + "</style>" + html;

    var w = sr.querySelector(".w");
    log("drawer geopend met", total, "kleuren");
    requestAnimationFrame(function () { w.classList.add("on"); });

    function close() {
      w.classList.remove("on");
      setTimeout(function () { host.remove(); }, 240);
    }
    sr.addEventListener("click", function (e) {
      if (e.target === w || (e.target.closest && e.target.closest(".x"))) { close(); return; }
      var s = e.target.closest && e.target.closest(".s");
      if (!s) return;
      var h = s.dataset.h;
      if (!h || h === me.handle) return;
      overlay("Kleur wordt geladen…");
      saveForNext();
      location.href = "/products/" + h;
    });
    document.addEventListener("keydown", function esc(e) {
      if (e.key === "Escape") { close(); document.removeEventListener("keydown", esc); }
    });
  }

  function mount(groups, me) {
    styles();
    var root = document.querySelector(".product-custom-option");
    if (!root) return false;
    /* wachten tot de configurator is opgebouwd, zodat alles in één keer
       tevoorschijn komt in plaats van de stalen eerst */
    var ready = root.querySelector(".slz-step__header") ||
      document.documentElement.classList.contains("slz-complete") ||
      root.querySelector(".optionHolder .swatch-input, .optionHolder .measurement-input");
    if (!ready) return false;
    if (root.querySelector(":scope > .slz-colors")) return true;

    var mine = groups[me.collection || "kleuren"] || [];
    var total = Object.keys(groups).reduce(function (n, k) { return n + groups[k].length; }, 0);
    if (total < 2) { log("geen kleurfamilie gevonden"); return true; }

    var box = document.createElement("div");
    box.className = "slz-colors";
    box.innerHTML =
      '<div class="slz-colors__head"><span class="slz-colors__title">Kleur' +
      "<span>" + (titleCase(me.color) || "") + "</span></span></div>" +
      '<div class="slz-colors__row"></div>';

    var row = box.querySelector(".slz-colors__row");
    var mobile = window.matchMedia && window.matchMedia("(max-width:749px)").matches;
    /* desktop: 5 stalen. mobiel: hele collectie, horizontaal te swipen. */
    var shown = mobile ? mine : mine.slice(0, MAX_SWATCHES);
    shown.forEach(function (it) { row.appendChild(swatch(it, me.handle)); });
    if (mobile) {
      row.classList.add("is-swipe");
      row.setAttribute("style",
        "display:flex!important;flex-wrap:nowrap!important;overflow-x:auto!important;" +
        "overflow-y:hidden!important;gap:10px!important;width:100%!important;max-width:100%!important;" +
        "padding:2px 2px 10px!important;margin:0!important;grid-template-columns:none!important;" +
        "-webkit-overflow-scrolling:touch;scrollbar-width:none");
      [].slice.call(row.children).forEach(function (c) {
        c.style.setProperty("flex", "0 0 auto", "important");
      });
      log("swipe-rij met", shown.length, "kleuren");
    }

    var others = Object.keys(groups).length > 1;
    if (total > shown.length || others) {
      var more = document.createElement("button");
      more.type = "button";
      more.className = "slz-colors__more";
      more.textContent = "Meer kleuren (" + total + ")";
      more.addEventListener("click", function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        try {
          openModal(groups, me);
        } catch (err) {
          console.error("[solerza-kleuren] drawer fout:", err && err.message, err);
        }
      });
      box.querySelector(".slz-colors__head").appendChild(more);
    }

    box.style.opacity = "0";
    box.style.transition = "opacity .22s ease";
    root.insertBefore(box, root.firstChild);
    requestAnimationFrame(function () { box.style.opacity = "1"; });
    log("stalen geplaatst:", mine.length, "van", total);
    return true;
  }

  /* ---------------- laadweergave ---------------- */
  function skeleton() {
    var root = document.querySelector(".product-custom-option");
    if (!root || root.querySelector(".slz-skel")) return;
    if (root.querySelector(".optionHolder")) return;
    var s = document.createElement("div");
    s.className = "slz-skel";
    var rows = "";
    for (var i = 0; i < 4; i++) {
      rows += '<div class="slz-skel__row"></div>';
    }
    s.innerHTML = rows;
    root.appendChild(s);

    var t = setInterval(function () {
      var r = document.querySelector(".product-custom-option");
      if (!r) { clearInterval(t); return; }
      if (r.querySelector(".optionHolder")) {
        var el = r.querySelector(".slz-skel");
        if (el) el.remove();
        clearInterval(t);
      }
    }, 200);
    setTimeout(function () {
      var el = document.querySelector(".slz-skel");
      if (el) el.remove();
      clearInterval(t);
    }, 12000);
  }

  function overlay(text) {
    var o = document.createElement("div");
    o.className = "slz-load";
    o.innerHTML = '<div class="slz-load__box"><span class="slz-load__dot"></span>' + text + "</div>";
    document.body.appendChild(o);
    requestAnimationFrame(function () { o.classList.add("is-on"); });
  }

  /* ---------------- start ---------------- */
  if (SKIP.some(function (r) { return r.test(handle()); })) {
    log("kleuren overgeslagen voor dit product:", handle());
    return;
  }

  var me = parse(handle());
  if (!me) {
    var hh = handle();
    if (!hh) return;
    /* geen kleurwoord gevonden: doorgaan met een lege basis, het
       jaloezie-profiel of de handle-vergelijking bepaalt de familie */
    log("handle niet direct te ontleden, profiel proberen:", hh);
    me = { base: hh.split("-").slice(0, 2).join("-"), dim: "", collection: "", color: "", handle: hh };
  }

  styles();
  restoreChoices();
  log("terugzetten gestart, opgeslagen:", sessionStorage.getItem(RESTORE_KEY) ? "ja" : "nee");

  /* Eén zeef over het eindresultaat: producten met een andere verduistering
     horen er nooit bij, ongeacht welke route de familie samenstelde. */
  function sift(groups, h) {
    var myDim = dimOf(h);
    var out = {};
    var seen = {};
    Object.keys(groups).forEach(function (k) {
      var keep = groups[k].filter(function (it) {
        if (dimOf(it.handle) !== myDim) return false;
        /* zelfde product onder twee handles (na een naamswijziging met
           doorverwijzing): alleen de eerste houden */
        var id = (it.title || it.handle).toLowerCase().replace(/\s+/g, " ").trim();
        if (seen[id]) return false;
        seen[id] = 1;
        return true;
      });
      if (keep.length) out[k] = keep;
    });
    return out;
  }

  /* Delen alle kleuren in een collectie dezelfde beginwoorden (bijv.
     "Click Aluminium Metallic Wit" / "... Metallic Zwart"), dan hoort dat
     stuk bij de stof en niet bij de kleur: eraf halen. */
  function trimShared(groups) {
    Object.keys(groups).forEach(function (k) {
      var list = groups[k];
      if (list.length < 2) return;
      var first = list[0].label.split(" ");
      var n = 0;
      for (var i = 0; i < first.length - 1; i++) {
        var w = first[i].toLowerCase();
        var all = list.every(function (it) {
          var p = it.label.split(" ");
          return p.length > i + 1 && p[i].toLowerCase() === w;
        });
        if (!all) break;
        n = i + 1;
      }
      if (!n) return;
      list.forEach(function (it) {
        var rest = it.label.split(" ").slice(n).join(" ");
        if (rest) it.label = rest;
      });
    });
    return groups;
  }

  loadProducts().then(function (items) {
    var groups = trimShared(sift(family(items, me), me.handle));
    var count = Object.keys(groups).reduce(function (n, k) { return n + groups[k].length; }, 0);
    /* Ook als de eerste route iets vond: de handle-vergelijking levert de
       andere materialen/houtsoorten op. Die nemen we er altijd bij, zodat
       "Meer kleuren" ook bij kleine collecties wat te tonen heeft. */
    var prof = familyByProfile(items, me.handle);
    if (prof) {
      groups = trimShared(sift(prof.groups, me.handle));
      me.collection = prof.me.material;
      me.color = prof.me.color;
      me.dim = prof.me.size + (prof.me.perf ? " · geperforeerd" : "");
      var pt = 0;
      var t = setInterval(function () {
        pt++;
        if (mount(groups, me) || pt > 120) clearInterval(t);
      }, 250);
      return;
    }

    var alt = familyByPrefix(items, me.handle);
    if (alt) {
      var altCount = Object.keys(alt).reduce(function (n, k) { return n + alt[k].length; }, 0);
      alt = trimShared(sift(alt, me.handle));
      altCount = Object.keys(alt).reduce(function (n, k) { return n + alt[k].length; }, 0);
      if (count < 2 || Object.keys(alt).length > Object.keys(groups).length || altCount > count) {
        groups = alt;
        me.collection = me.handle.split("-")[0];
        var own = alt[me.collection] || [];
        var mineNow = own.filter(function (i) { return i.handle === me.handle; })[0];
        if (mineNow) me.color = mineNow.color;
      }
    }
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (mount(groups, me) || tries > 120) clearInterval(t);
    }, 250);
  });
})();
